// Common utility styles
export const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: "1px",
  height: "1px",
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  clip: "rect(0 0 0 0)",
};

// Calculates empty rows for pagination
export function emptyRows(page, rowsPerPage, arrayLength) {
  return page ? Math.max(0, (1 + page) * rowsPerPage - arrayLength) : 0;
}

// Comparator for sorting
function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null) return 1;
  if (b[orderBy] === null) return -1;
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function applyFilter({
  inputData,
  comparator,
  filterName = "",
  filterCategory = "",
}) {
  if (!Array.isArray(inputData)) return [];

  const stabilizedData = inputData.map((el, index) => [el, index]);

  stabilizedData.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    return order !== 0 ? order : a[1] - b[1];
  });

  let filteredData = stabilizedData.map((el) => el[0]);

  if (filterName) {
    const nameFilter = filterName.toLowerCase();
    filteredData = filteredData.filter((item) =>
      Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(nameFilter)
      )
    );
  }

  if (filterCategory) {
    const categoryFilter = filterCategory.toLowerCase();

    // Normalize status safely
    const normalizeStatus = (str) =>
      str
        ?.toString()
        .toLowerCase()
        .replace(/[\s&-]+/g, "") || "";

    filteredData = filteredData.filter((item) =>
      Object.values(item).some((value) =>
        normalizeStatus(value).includes(normalizeStatus(categoryFilter))
      )
    );
  }



  return filteredData;
}
